import { useMutation } from 'react-query';
import { getPlanById } from '../../../../api/services/mediaPlanning/getPlanById';
import usePlanStore from '../../../../store/planStore';

const useMediaPlanMetaSync = () => {
  const { updateMetaPredictionsState } = usePlanStore();

  const { mutate: syncMediaPlan, isLoading } = useMutation({
    mutationFn: (id: string | null) => getPlanById(id ?? ''),
    onSuccess: ({ data }) => {
      Object.entries(data.countrySetup).forEach(([key, value]) => {
        updateMetaPredictionsState(
          key,
          value.metaConfig?.metaCampaignId,
          value.metaConfig?.metaPredictionId
        );
      });
    },
  });

  return { syncMediaPlan, isLoading };
};

export default useMediaPlanMetaSync;
